import { render, staticRenderFns } from "./ResourcesLearningEnvComponent.vue?vue&type=template&id=f02a85b0&scoped=true"
import script from "./ResourcesLearningEnvComponent.vue?vue&type=script&lang=js"
export * from "./ResourcesLearningEnvComponent.vue?vue&type=script&lang=js"
import style0 from "./ResourcesLearningEnvComponent.vue?vue&type=style&index=0&id=f02a85b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02a85b0",
  null
  
)

export default component.exports